exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.seo-text-box[data-v-41e2dc50] {\n    max-height: 250px;\n    position: relative;\n    overflow: hidden;\n}\n.seo-text-box .read-more[data-v-41e2dc50] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    padding-top: 60px;\n\n    background-image: linear-gradient(to bottom, transparent, white);\n}\n", ""]);

// exports
